// Final CTA — the "manifeste" moment with the Damasio quote.
// Renamed to ManifestoCTA to avoid clashing with the standalone manifesto page.

import type { MouseEvent } from 'react';
import { Reveal } from '../components/Reveal';
import { Arrow } from '../components/Atoms';

export const TALLY_FORM_ID = 'Xx0v5V';

function openTally(e: MouseEvent<HTMLAnchorElement>) {
  e.preventDefault();
  if (typeof window === 'undefined' || !window.Tally) return;
  window.Tally.openPopup(TALLY_FORM_ID, { layout: 'modal', width: 700, autoClose: 3000 });
}

export function ManifestoCTA() {
  return (
    <section className="manifesto" id="acces" data-screen-label="07 Manifeste">
      <div className="wrap">
        <span className="quote-mark">“</span>
        <Reveal as="blockquote">
          <em>
            Avant les plateformes, avant les algorithmes, avant l'IA générative, il y avait quelqu'un qui disait à quelqu'un d'autre :<br />écoute ça.
          </em>
        </Reveal>
        <div className="ascription">manifeste — furtif.fm · 2026</div>
        <a href="#acces" className="btn" onClick={openTally}>
          Rejoindre l'accès anticipé <Arrow />
        </a>
      </div>
    </section>
  );
}
